"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalizedUrl = exports.parseUtmParams = exports.getAppRoot = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var isUI = window.location.origin.indexOf('app.hubspotqa.com') > -1;
var APP_ROOT = _enviro.default.deployed() && !isUI ? '/' : '/websitegrader/';
var LANG_REGEX = /^\/(de|en|pt|ja|es|fr)/gm;

var getAppRoot = function getAppRoot() {
  var lang = window.I18N_MANUAL_LANG;

  if (lang === 'en') {
    return APP_ROOT;
  }

  return "" + lang + APP_ROOT;
};

exports.getAppRoot = getAppRoot;

var parseUtmParams = function parseUtmParams() {
  if (!window.location.search) return '';
  var searchParams = window.location.search.slice(1).split('&').filter(function (param) {
    return param.indexOf('utm_') !== -1;
  });
  return searchParams.join('&');
};

exports.parseUtmParams = parseUtmParams;

var getLocalizedUrl = function getLocalizedUrl(lang) {
  var _window$location = window.location,
      origin = _window$location.origin,
      pathname = _window$location.pathname;
  var parsedUtmParams = parseUtmParams();
  var path = pathname.replace(LANG_REGEX, '');
  var utmParams = parsedUtmParams ? "?" + parsedUtmParams : '';
  var langFragment = lang === 'en' ? '' : "/" + lang;
  return "" + origin + langFragment + path + utmParams;
};

exports.getLocalizedUrl = getLocalizedUrl;


//////////////////
// WEBPACK FOOTER
// ./js/util/Urls.js
// module id = 19
// module chunks = 0